/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import { kebabCase } from 'lodash';
import React from 'react';

import { ButtonBase } from '@mui/material';

import { useEntitiesListStyles } from './EntitiesList.styles';

type EntitiesListItemProps = {
  className?: string;
  onClick?: () => any;
  icon?: React.ReactElement<any>;
  text: string;
};

export function EntitiesListItem(props: EntitiesListItemProps) {
  const { className = '', onClick, icon, text } = props;
  const classes = useEntitiesListStyles();
  return (
    <ButtonBase className={cx(className, classes.itemWrap)} classes={{ root: classes.itemRoot }} onClick={onClick}>
      <div className={classes.itemIcon}>{icon}</div>
      <div className={classes.itemText} data-cy={`${kebabCase(text)}-organization`}>
        {text}
      </div>
    </ButtonBase>
  );
}
